import {Component, OnInit} from "@angular/core";
import {FormGroup, FormControl, Validators} from "@angular/forms";
import {UserService} from "../../../shared/services/api_v1/user.service";
import {Router} from "@angular/router";

@Component({
    // moduleId: module.id,
    selector:'home-login-form',
    templateUrl: './home-login-form.component.html'
})
export class HomeLoginFormComponent implements OnInit{
    myGroup: FormGroup;

    login_failed = false;
    submitted = false;
    button_disabled = false;

    url_called;

    constructor(private userService:UserService, private router: Router){}

    ngOnInit() {
        this.myGroup = new FormGroup({
            email: new FormControl('',[ Validators.required ]),
            password: new FormControl('',[ Validators.required ])
        });
    }

    login(): void {
        if(this.myGroup.invalid){ return; }

        this.submitted = false;
        this.button_disabled = true;

        this.url_called = this.userService.login(
            this.myGroup.get('email').value,
            this.myGroup.get('password').value
        ).subscribe(() => {
                this.submitted = true;
                this.login_failed = false;
                this.button_disabled = false;
                this.router.navigateByUrl('/upload');
            },
            () =>{
                this.submitted = true;
                this.login_failed = true;
                this.button_disabled = false;
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/front/home/login/home-login-form.component.ts